let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("762BX")).then(() => parcelRequire('2sxFh'));